import { NumericFormatKinds } from ".";

export class NumericInputFormatter {
  public static format(text: string, kind: NumericFormatKinds): string {
    if (!text) { return text; }
    switch (kind) {
      case NumericFormatKinds.Money:
        return this.formatToMoney(text);
      case NumericFormatKinds.Normal:
      default:
        // V1はカンマも許容するようなので、同様に許容させている
        return text.replace(/[^-^0-9^\.^,]/g, "");
    }
  }

  /**
   * 数字3桁ごとにカンマを挿入する
   * 小数点にも対応する必要あり
   */
  private static formatToMoney(text: string): string {
    const chars = this.getTargetChars(text);
    const periodIndex = chars.indexOf(".");
    const baseIndex = periodIndex > 0 ? periodIndex : chars.length;
    const commaInsertIndexes: number[] = [];
    for (let index = baseIndex - 3; index > 0; index = index - 3) {
      if (index === 1) {
        if (/[0-9]/.test(chars[0])) {
          commaInsertIndexes.push(1);
        }
        continue;
      }
      commaInsertIndexes.push(index);
    }
    // 後ろからカンマを足していく
    for (const commaInsertIndex of commaInsertIndexes) {
      chars.splice(commaInsertIndex, 0, ",");
    }
    return chars.join("");
  }

  private static getTargetChars(text: string): string[] {
    const filtered = text.replace(/[^-^\d^\.]/g, "");
    if (!(/[0-9]/.test(filtered))) {
      // 数値が含まれていない場合
      return filtered.split("");
    }
    const extracted = filtered
      .replace(/^(0(?!\.))*/, "")       // 先頭の連続する「0」を除去.
      .replace(/(?!^)-/g, "")           // 先頭以外の「-」を除去.
      .replace(/-(0(?!\.))*/g, "-");     // 「-」の後の連続する「0」を除去.
    
    // 「.」より後の末尾の連続する「0」を除去.
    // IE11では肯定後読みの正規表現が動かない模様.(chromeでは動く.)
    const lastZeroSuppressed = /\./.test(extracted)
      ? extracted.replace(/0+$/, "")
      : extracted;
    
    return lastZeroSuppressed
      .replace(/\.$/, "")               // 末尾の「.」を除去.
      .replace(/^\./, "0\.")            // 先頭が「.」の場合は「0」を追加.
      .replace(/^-\./, "-0\.")          // 先頭が「-.」の場合は「0」を追加.
      .replace(/^((-0)|(-)|())$/, "0")  // 空になったら「0」.
      .split("");
  }

  public static toDigit(text: string): string {
    if (!text) { return text; }
    return text.replace(/[^-^0-9^\.]/g, "");
  }
}
